export const AGENCIES_COLLECTION_QUERY_KEY = 'agencies';
export const AGENCY_TOKEN = 'agency-token';

export const CONTENT_ENTITY_QUERY_KEY = 'content';
export const CONTENTS_COLLECTION_QUERY_KEY = 'contents';

export const CONTENTS_PDF_COLLECTION_QUERY_KEY = 'pdf-list';

export const GET_CONTENT_QUERY_KEY = 'get-content';
export const GET_SELECTED_CONTENTS_QUERY_KEY = 'get-selected-contents';

export const MEDIA_PACK_ENTITY_QUERY_KEY = 'media-pack';
export const MEDIA_PACKS_COLLECTION_QUERY_KEY = 'media-packs';

export const VISIBILITY_ENTITY_QUERY_KEY = 'visibility';

export const BENCHMARK_ENTITY_QUERY_KEY = 'benchmark';

export const CREATOR_INSIGHT_ENTITY_QUERY_KEY = 'creator-insight';

export const INVITATIONS_COLLECTION_QUERY_KEY = 'invitations';
export const ACCEPTED_INVITATIONS_COLLECTION_QUERY_KEY = 'accepted-invitations';

export const MANAGER_ENTITY_QUERY_KEY = 'manager';

export const CREATOR_ENTITY_QUERY_KEY = 'creator';
export const CREATORS_COLLECTION_QUERY_KEY = 'creators';

export const YT_CONTENT_ENTITY_QUERY_KEY = 'yt-content';
export const YT_CONTENTS_COLLECTION_QUERY_KEY = 'yt-contents';

export const YT_CHANNEL_ENTITY_QUERY_KEY = 'yt-channel';

export const NOTIFICATIONS_COLLECTION_QUERY_KEY = 'notifications';

export const SETTINGS_COLLECTION_QUERY_KEY = 'settings';

export const USER_SETTINGS_QUERY_KEY = 'user-settings';

export const NOTIFICATIONS_SUMMARY_QUERY_KEY = 'notifications-summary';

export const TIKTOK_CONTENT_QUERY_KEY = 'tiktok-content';
export const TIKTOK_INSIGHTS_QUERY_KEY = 'tiktok-insights';

export const YOUTUBE_CHANNEL_INSIGHTS_QUERY_KEY = 'youtube-channel-insights';

export const USER_INVITATION_STATUS_QUERY_KEY = 'invitation-status';

export const USER_ECHO_MESSAGES_QUERY_KEY = 'echo-message-count';

export const LOCATION_SEARCH = 'location-search';
export const CREATOR_PROFILE_QUERY_KEY = 'creator-profile';

export const CREATOR_CONTENT_QUERY_KEY = 'creator-content';

export const TR_CREATORS_LIST_QUERY_KEY = 'tr-creators-list';
export const MY_TALENT_ROSTER_QUERY_KEY = 'my-talent-roster';
export const ALL_TALENT_ROSTER_QUERY_KEY = 'all-talent-roster';

export const WHALAR_MODE_ROSTER_QUERY_KEY = 'whalar-mode-talent-roster';
export const WHALAR_MODE_TALENT_SEARCH_QUERY_KEY = 'whalar-mode-talent-search';
export const WHALAR_MODE_LISTS_SEARCH_QUERY_KEY = 'whalar-mode-lists-search';

export const SAVED_LISTS = 'saved-list';
export const AGENCY_SAVED_LISTS = 'agency-saved-list';
export const SAVED_LIST_CREATORS = 'saved-list-creators';
export const SAVED_LIST_CREATORS_SEARCH = 'saved-list-creators-search';
export const SHARED_SAVED_LISTS = 'shared-saved-list';

export const WHALAR_MODE_LISTS = 'whalar-mode-lists';
export const WHALAR_MODE_LIST = 'whalar-mode-list';
export const WHALAR_MODE_LIST_IMPORT_STATUS = 'whalar-mode-list-import-status';
export const WHALAR_MODE_LIST_CREATORS = 'whalar-mode-list-creators';
export const WHALAR_MODE_TALENT_BENCHMARKS = 'whalar-mode-talent-benchmarks';
export const WHALAR_MODE_TALENT_IG_INSIGHTS = 'whalar-mode-talent-ig-insights';
export const WHALAR_MODE_TALENT_TT_INSIGHTS = 'whalar-mode-talent-tt-insights';
export const WHALAR_MODE_TALENT_YT_INSIGHTS = 'whalar-mode-talent-yt-insights';
export const WHALAR_MODE_LISTS_CREATORS_BENCHMARKS =
  'whalar-mode-lists-creators-benchmarks';
export const WHALAR_MODE_LISTS_CREATORS_INSIGHTS =
  'whalar-mode-lists-creators-insights';
export const WHALAR_MODE_SUBMIT_SMART_PROFILES_INFORMATION =
  'whalar-mode-submit-smart-profiles-information';

export const USER_ACCESS_QUERY_KEY = 'user-access';

export const AGENCY_MANAGEMENT_CREATORS_COLLECTION_QUERY_KEY =
  'agency-management-creators';
export const AGENCY_MANAGEMENT_REQUESTS_COLLECTION_QUERY_KEY =
  'agency-management-requests';
export const AGENCY_MANAGERS_COLLECTION_QUERY_KEY = 'agency-managers';
export const CREATORS_INVITATIONS_QUERY_KEY = 'talent-invitations';

export const SHARE_LINKS_KEY = 'share-links';
export const LOCATION_DETAILS_KEY = 'location-details';
export const CO_MANAGERS_REQUESTS_KEY = 'co-managers-requests';

export const MEDIA_KIT = 'media-kit';
export const CREATOR_BENCHMARKS = 'creator-benchmarks';
export const AGENCIES = 'agencies';

export const GLOBAL_SEARCH_TALENT_QUERY_KEY = 'global-search-talent';
export const GLOBAL_SEARCH_TTA_QUERY_KEY = 'global-search-tta';
export const GLOBAL_SEARCH_CONTENT_QUERY_KEY = 'global-search-content';
export const GLOBAL_SEARCH_AGENCY_LISTS_QUERY_KEY =
  'global-search-agency-lists';
export const GLOBAL_SEARCH_LISTS_QUERY_KEY = 'global-search-lists';
export const RECENT_SEARCHES_QUERY_KEY = 'recent-searches';
export const CREATOR_ON_PLATFORM_BY_EMAIL = 'creator-on-platform-by-email';

export const BRANDFETCH_SEARCH_QUERY_KEY = 'brandfetch-search';
